import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React from "react";
import Icon from "@shared/components/Icon";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Link from "@shared/components/contents/link/Link";
import Surtitle from "../Surtitle";
const CardsGrid = (props) => {
    const { id, dynamicList: items = [], ...others } = props;
    return (_jsx(Grid, { container: true, spacing: 2.5, ...others, children: items?.map((item, index) => (_jsx(Grid, { size: { xs: 12, sm: index === 0 ? 12 : 6, md: index === 0 ? 6 : 3 }, children: _jsxs(Card, { index: index, children: [item.icon && item.icon?.icon && (_jsx(Box, { className: "card-icon", sx: {
                            position: "relative",
                            zIndex: 1,
                            "& > *": {
                                borderRadius: "initial !important",
                                fontSize: "24px",
                                width: "40px !important",
                                height: "40px !important",
                            },
                        }, children: _jsx(Icon, { ...item.icon }) })), _jsxs(Stack, { spacing: 2.5, sx: {
                            position: "relative",
                            zIndex: 1,
                            ...(index > 0 && { mt: "auto" }),
                        }, divider: index > 0 && (_jsx(Divider, { sx: { borderColor: "border.separator" } })), children: [item.title && (_jsx(Surtitle, { title: item.title, component: index === 0 ? "h2" : "p", contrast: index === 0 })), item.subtitle && (_jsx(Typography, { variant: index === 0 ? "h4" : "subtitle1", component: index === 0 ? "p" : "h3", sx: {
                                    color: index === 0 ? "primary.contrastText" : undefined,
                                }, children: item.subtitle })), item.description && (_jsx(Typography, { variant: "subtitle2", component: "p", sx: {
                                    color: index === 0 ? "primary.contrastText" : undefined,
                                    height: index === 0 ? "unset" : "65px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: "vertical",
                                }, children: item.description }))] }), item.link && (item.link.page || item.link.url) && (_jsx(Box, { className: index > 0 ? "card-button-bar" : undefined, sx: {
                            position: "relative",
                            zIndex: 1,
                            ...(index > 0
                                ? {
                                    position: "absolute",
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    height: 0,
                                    overflow: "hidden",
                                    backgroundColor: "background.dark",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    transition: "height 0.3s ease",
                                }
                                : {
                                    display: "flex",
                                    justifyContent: "flex-end",
                                }),
                        }, children: _jsx(Button, { variant: index === 0 ? "outlined" : "text", endIcon: _jsx(Icon, { icon: "arrow-right" }), component: Link, ...item.link, sx: {
                                color: "primary.contrastText",
                                ...(index === 0 && {
                                    backgroundColor: "background.main",
                                    borderColor: "primary.contrastText",
                                }),
                            }, children: item.link.title }) }))] }) }, item.title + (item.subtitle ?? "") + index))) }, id));
};
const Card = ({ children, index, }) => {
    return (_jsx(Stack, { spacing: 2, sx: {
            position: "relative",
            overflow: "hidden",
            padding: 3,
            paddingBottom: 3,
            justifyContent: "space-between",
            height: { xs: "auto", md: "290px" },
            backgroundColor: index === 0 ? "background.main" : "background.paper",
            border: "1px solid",
            borderColor: "border.grey",
            transition: "padding-bottom 0.3s ease",
            ...(index > 0 && {
                "&:hover, &:focus-within": {
                    paddingBottom: "84px",
                    "& .card-button-bar": {
                        height: "56px",
                    },
                },
            }),
        }, children: children }));
};
export default CardsGrid;
